import type { PrimaryFilterId } from '../../../filters/types/filters';
import { ChartFallback } from '../../Chart/ChartFallback';
import type { DataProviderChildren, SingleDataSet } from '../types';
import { computeMarketTightnessDataSet } from './market-condition-metrics-utils';
import { useCompositionAndPostingsQueries } from './useCompositionAndPostingsQueries';

export const MarketTightnessDataProvider = ({
  primaryDimension,
  children,
}: {
  primaryDimension: PrimaryFilterId;
  children: DataProviderChildren<SingleDataSet | undefined>;
}) => {
  const { compositionData, postingsData, status } =
    useCompositionAndPostingsQueries(primaryDimension);

  const data: SingleDataSet | undefined =
    compositionData && postingsData
      ? computeMarketTightnessDataSet(compositionData, postingsData)
      : undefined;

  return (
    <ChartFallback status={status}>{children({ data, status })}</ChartFallback>
  );
};
